const SYSTEM_ROUTE = [
  {
    path: 'system/supplierManagement',
    name: 'SupplierManagement',
    component: () => import('@/views/system/supplierManagement'),
    meta: {
      title: '供应商管理',
      icon: '',
      keepAlive: true,
    },
  },
]

export default SYSTEM_ROUTE
